import React from 'react';
import { func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';

import css from './BlockDefault.module.css';

const FieldMedia = React.memo(props => {
  const { className, media, sizes, options } = props;
  const hasMediaField = hasDataInFields([media], options);
  return hasMediaField ? (
    <div className={classNames(className, css.media)}>
      <Field data={media} sizes={sizes} options={options} />
    </div>
  ) : null;
});

const BlockDefault = React.memo(props => {
  const {
    blockId,
    className,
    rootClassName,
    mediaClassName,
    textClassName,
    ctaButtonClass,
    title,
    text,
    callToAction,
    media,
    responsiveImageSizes,
    options,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const hasTextComponentFields = hasDataInFields([title, text, callToAction], options);

  return (
    <>
      {blockId === "shop" ?
        <div className={css.shopSection}>
          <a  href="/s/products"className={css.shopBox}>
            <div className={css.shopHeading}>
              Shop:
            </div>
            <div className={css.shopTitle}>Products</div>
          </a>
          <a  href="/s/services" className={css.shopBox}>
            <div className={css.shopHeading}>
              Shop:
            </div>
            <div className={css.shopTitle}>Services</div>
          </a>
          <a href="/s/shop-by-food&drink" className={css.shopBox}>
            <div className={css.shopHeading}>
              Shop:
            </div>
            <div className={css.shopTitle}>Food & Drink</div>
          </a>
          <a href="/s/shop-by-merchants" className={css.shopBox}>
            <div className={css.shopHeading}>
              Shop:
            </div>
            <div className={css.shopTitle}>Merchants</div>
          </a>
        </div> :
        <BlockContainer id={blockId} className={classes}>
          <FieldMedia
            media={media}
            sizes={responsiveImageSizes}
            className={mediaClassName}
            options={options}
          />
          {hasTextComponentFields ? (
            <div className={classNames(textClassName, css.text)}>
              <Field data={title} options={options} />
              <Field data={text} options={options} />
              <Field data={callToAction} className={ctaButtonClass} options={options} />
            </div>
          ) : null}
        </BlockContainer>}
    </>
  );
});

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

BlockDefault.defaultProps = {
  className: null,
  rootClassName: null,
  mediaClassName: null,
  textClassName: null,
  ctaButtonClass: null,
  title: null,
  text: null,
  callToAction: null,
  media: null,
  responsiveImageSizes: null,
  options: null,
};

BlockDefault.propTypes = {
  blockId: string.isRequired,
  className: string,
  rootClassName: string,
  mediaClassName: string,
  textClassName: string,
  ctaButtonClass: string,
  title: object,
  text: object,
  callToAction: object,
  media: object,
  responsiveImageSizes: string,
  options: propTypeOption,
};

export default BlockDefault;
